import { BaseButton, BaseNavLink } from '@enter/core';
import { mdiEmailOutline, mdiEmailArrowRight, mdiMailboxOpenUpOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { DataTableCard, PageLayout, PageLayoutHeader, PageLayoutRow, PageLayoutTitle } from 'components';
import React from 'react';
import { useParams } from 'react-router-dom';
import { InboxMail } from './inbox/inbox';
import * as S from './mail.styles';
import { OutboxMail } from './outbox/outbox';
import { Shipment } from './shipment/shipment';

export const Mail = () => {
    const { tab } = useParams<{ tab: 'inbox' | 'outbox' | 'shipment' }>();

    return (
        <PageLayout>
            <PageLayoutRow>
                <PageLayoutHeader>
                    <PageLayoutTitle>Mail</PageLayoutTitle>
                </PageLayoutHeader>
            </PageLayoutRow>
            <PageLayoutRow>
                <DataTableCard size="large">
                    <S.TabsContainer>
                        <BaseNavLink to="/mail/inbox" disabled={tab === 'inbox'}>
                            {(linkProps): React.ReactElement => (
                                <BaseButton variant="outlined" disabled={linkProps.active}>
                                    <Icon path={mdiEmailOutline} size={0.75} />
                                    <span>Inbox</span>
                                </BaseButton>
                            )}
                        </BaseNavLink>
                        <BaseNavLink to="/mail/outbox" disabled={tab === 'outbox'}>
                            {(linkProps): React.ReactElement => (
                                <BaseButton variant="outlined" disabled={linkProps.active}>
                                    <Icon path={mdiEmailArrowRight} size={0.75} />
                                    <span>Outbox</span>
                                </BaseButton>
                            )}
                        </BaseNavLink>
                        <BaseNavLink to="/mail/shipment" disabled={tab === 'shipment'}>
                            {(linkProps): React.ReactElement => (
                                <BaseButton variant="outlined" disabled={linkProps.active}>
                                    <Icon path={mdiMailboxOpenUpOutline} size={0.75} />
                                    <span>Shipment</span>
                                </BaseButton>
                            )}
                        </BaseNavLink>
                    </S.TabsContainer>

                    {tab === 'inbox' && <InboxMail />}
                    {tab === 'outbox' && <OutboxMail />}
                    {tab === 'shipment' && <Shipment />}
                </DataTableCard>
            </PageLayoutRow>
        </PageLayout>
    );
};
